export function handleProgressBar({
  setLoadingState,
  totalDurationMs,
  incrementMs = 200,
  maxProgress = 97,
  finalMessage = "Almost done! Fetching your output",
  showFinalMessage = true,
  messageList = [],            
  messageDurations = [],      
}) {
  let progressInterval = null;
  let stop = false;

  const start = (initialMessage = "") => {
    let progress = 0;
    let finalMessageShown = false;

    // Initial state
    setLoadingState({ open: true, message: initialMessage, progress: 0 });

    //  Message Rotation for custom durations
    if (messageList.length > 0 && messageDurations.length === messageList.length) {
      let index = 0;

      const showNextMessage = () => {
        if (stop || finalMessageShown || index >= messageList.length) return;

        setLoadingState((prev) => ({
          ...prev,
          message: messageList[index],
        }));

        setTimeout(() => {
          index++;
          showNextMessage(); 
        }, messageDurations[index]);
      };

      showNextMessage(); 
    }

    // Progress Bar Interval Logic
    const increment = (maxProgress * incrementMs) / totalDurationMs;

    progressInterval = setInterval(() => {
      if (stop) return;

      progress += increment;

      if (progress >= maxProgress && !finalMessageShown && showFinalMessage) {
        finalMessageShown = true;
        setLoadingState((prev) => ({
          ...prev,
          message: finalMessage,
        }));
      }

      if (progress > maxProgress) progress = maxProgress;

      setLoadingState((prev) => ({
        ...prev,
        progress: Math.max(prev.progress, Math.floor(progress)),
      }));
    }, incrementMs);
  };

  const updateMessage = (message) => {
    setLoadingState((prev) => ({
      ...prev,
      message,
    }));
  };

  const stopProgress = () => {
    stop = true;
    if (progressInterval) clearInterval(progressInterval);
  };

  const completeTo100 = async () => {
    stopProgress();
    setLoadingState((prev) => ({
      ...prev,
      progress: 100,
    }));
    await new Promise((res) => setTimeout(res, 500));
  };

  const finishAndClose = async () => {
    await completeTo100();
    setLoadingState({ open: false, message: "", progress: null });
  };

  return {
    start,
    updateMessage,
    stop: stopProgress,
    completeTo100,
    finishAndClose,
  };
}
